import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { createClient } from '@supabase/supabase-js';
import LoadingPage from '../pages/LoadingPage';

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL!,
  process.env.REACT_APP_SUPABASE_ANON_KEY!
);

interface UserInfo {
  email: string;
  fullName: string;
  // Ajoutez d'autres champs si nécessaire
}

interface PrivateRouteProps {
  darkMode: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ darkMode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const { data: { user }, error } = await supabase.auth.getUser();
        console.log("Supabase getUser response:", user);

        if (error) {
          throw error;
        }

        if (user) {
          const newUserInfo: UserInfo = {
            email: user.email || '',
            fullName: user.user_metadata?.full_name || '',
            // Ajoutez d'autres champs si nécessaire
          };

          const storedUserInfo = localStorage.getItem('userInfo');
          if (storedUserInfo) {
            const parsedUserInfo = JSON.parse(storedUserInfo);
            if (JSON.stringify(parsedUserInfo) !== JSON.stringify(newUserInfo)) {
              setUserInfo(newUserInfo);
              localStorage.setItem('userInfo', JSON.stringify(newUserInfo));
            } else {
              setUserInfo(parsedUserInfo);
            }
          } else {
            setUserInfo(newUserInfo);
            localStorage.setItem('userInfo', JSON.stringify(newUserInfo));
          }

          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
          setUserInfo(null);
          localStorage.removeItem('userInfo');
        }
      } catch (error) {
        console.error("Error checking authentication:", error);
        setIsAuthenticated(false);
        setUserInfo(null);
        localStorage.removeItem('userInfo');
      }
    };

    checkAuth();
  }, []);

  useEffect(() => {
    const { data: authListener } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_OUT') {
        localStorage.removeItem('userInfo');
        setIsAuthenticated(false);
        setUserInfo(null);
      }
    });

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, []);

  if (isAuthenticated === null) {
    return <LoadingPage darkMode={darkMode} />;
  }

  return isAuthenticated ? <Outlet context={{ userInfo }} /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;